/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';
import { IBlock } from '@datatype/type';
import BoxBlock from '@component/common/block/box-block';
import { useClicker } from '@hook/common/useEvent';

interface IProps {
  src: string;
  alt: string;
  design: Pick<IBlock['design'], 'box' | 'image'>;
  click?: IBlock['click'];
}

const ImageBlock: React.FC<IProps> = ({ src, alt, design, click }) => {
  const clicker = useClicker(click?.handler, click?.delay, click?.mode);

  return (
    <BoxBlock design={{ box: design.box }} onClick={clicker} css={css`overflow: hidden;`}>
      <img
        src={src}
        alt={alt}
        css={css`
          width: ${design?.image?.width};
          object-fit: contain;
          height: ${design.image?.height};
        `}
      />
    </BoxBlock>
  );
};

export default ImageBlock;
